module.exports = __webpack_public_path__ + "img/deviceOnline.74b0715f.svg";